const TYPE = 'INVALID_CONTENT_ERROR';
export class InvalidContentError extends Error {
    type = TYPE;
}
export function isInvalidContentError(error) {
    return Boolean(error instanceof Error && 'type' in error && error.type === TYPE);
}
//# sourceMappingURL=invalid-content-error.js.map